import { useReducer } from 'react';

/*
  How to use
  const [state, setState] = useSimpleReducer({enabled: false, data: null});

  setState({enabled: true, data: 1});

  Multiple React.useState may have delay between setState,
  Sometimes it needs different state to be effective at exact same time
  This hooks allows setting different state at the same time
*/

export default function useSimpleReducer(initialState) {
  return useReducer(
    (state, action) => {
      if (typeof action === 'function') {
        return {
          ...state,
          ...action(state),
        }
      } else {
        return {
          ...state,
          ...action,
        }
      }
    },
    initialState,
  );
}
